import { websocket$ } from 'sync/websocket$';
import { filter, map, withLatestFrom } from 'rxjs';
import { currentOrganizationId$ } from 'streams/organizations/currentOrganizationId$';
import {
  isChatMessageContentEvent,
  isChatMessageDoneEvent,
  isChatMessageErrorEvent,
  isChatMessageToolCallEvent,
  isChatMessageToolResultEvent,
  isChatSessionConcludedEvent,
  isChatSessionNotificationReadEvent,
  isChatSessionTitleGeneratedEvent,
  isChatInteractionRequestedEvent,
  isChatInteractionResolvedEvent,
  isChatPlanEvent,
} from './isChatEvent';

export const websocketChatMessageContent$ = websocket$.pipe(
  filter(isChatMessageContentEvent),
  filter(messageEvent => !messageEvent.data.is_sub_agent)
);

export const websocketChatMessageToolCall$ = websocket$.pipe(
  filter(isChatMessageToolCallEvent)
);

export const websocketChatMessageToolResult$ = websocket$.pipe(
  filter(isChatMessageToolResultEvent)
);

export const websocketChatMessageDone$ = websocket$.pipe(
  filter(isChatMessageDoneEvent)
);

export const websocketChatMessageError$ = websocket$.pipe(
  filter(isChatMessageErrorEvent)
);

export const websocketChatInteractionRequested$ = websocket$.pipe(
  filter(isChatInteractionRequestedEvent),
  map(event => event.data)
);

export const websocketChatInteractionResolved$ = websocket$.pipe(
  filter(isChatInteractionResolvedEvent),
  map(event => event.data)
);

export const websocketChatPlanEvent$ = websocket$.pipe(
  filter(isChatPlanEvent),
  map(event => event.data)
);

export const websocketChatSessionConcluded$ = websocket$.pipe(
  filter(isChatSessionConcludedEvent),
  map(event => event.data)
);

export const websocketChatSessionNotificationRead$ = websocket$.pipe(
  filter(isChatSessionNotificationReadEvent),
  map(event => event.data)
);

export const websocketChatSessionTitleGenerated$ = websocket$.pipe(
  filter(isChatSessionTitleGeneratedEvent),
  map(event => event.data.chatSession),
  withLatestFrom(currentOrganizationId$),
  filter(([chatSession, currentOrgId]) => chatSession.orgId === currentOrgId),
  map(([chatSession]) => chatSession)
);
